// extracted by mini-css-extract-plugin
export var title = "index-module--title--3klyl";
export var weightNormal = "index-module--weightNormal--2Xoo0";
export var sizeMobileLarge = "index-module--sizeMobileLarge--1chLN";
export var sizeMobileMedium = "index-module--sizeMobileMedium--3GnuD";
export var sizeMobileSmall = "index-module--sizeMobileSmall--Y5F_8";
export var sizeDesktopLarge = "index-module--sizeDesktopLarge--YjoGs";
export var sizeDesktopMedium = "index-module--sizeDesktopMedium--3190G";
export var sizeDesktopSmall = "index-module--sizeDesktopSmall--27wIZ";